<template>
  <div v-bind:class="['col-4', tableClass]">
    <div v-bind:class="['corner-rl', 'd-flex', 'justify-content-start', 'align-items-center', name + '-icon']">
      <div class="icon" style="margin: 0 5px;"><base-icon v-bind:name="(icon? icon: name)" /></div>
      <div style="font-size: 14px">{{ title }}</div>
    </div>
    <div v-bind:class="['d-flex', 'flex-column', 'corner-rl', name + '-bg']">
      <div class="container">
        <supplier-r-f-q-row v-bind:tableName="name" v-bind:data="data" title="Awaiting Submission" name="awaitingSubmission" rowClass="pt-1"/>
        <supplier-r-f-q-row v-bind:tableName="name" v-bind:data="data" title="Submitted" name="submitted" />
        <supplier-r-f-q-row v-bind:tableName="name" v-bind:data="data" title="New Responses" name="newResponses" />
        <supplier-r-f-q-row v-bind:tableName="name" v-bind:data="data" title="Awaiting Selection" name="awaitingSelection" />
        <supplier-r-f-q-row v-bind:tableName="name" v-bind:data="data" title="Past Due" name="pastDue" />
        <supplier-r-f-q-row v-bind:tableName="name" v-bind:data="data" title="Awarded" name="awarded" rowClass="mb-1" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import SupplierRFQRow from './SupplierRFQRow.vue'
import BaseIcon from '../../components/icons/BaseIcon.vue'

export default {
  name: 'SupplierRFQTable',
  props: ['name', 'title', 'icon', 'data', 'tableClass'],
  components: {
    BaseIcon,
    SupplierRFQRow
  },
  async mounted () {
  }, // end mounted
}

</script>


// WEBPACK FOOTER //
// SupplierRFQTable.vue?975b89e4